
export const accountUsersLimit = 64
export const contentEditorLimit = 32
export const channelTacticsLimit = 10
export const channelSelectionLimit = 15